// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__GQKhh","spinner":"SubmitButton_spinner__u1NJm","spin":"SubmitButton_spin__GOJkb","icon":"SubmitButton_icon__e--YQ"};